import {extend} from 'flarum/extend';
import CustomDiscussionSearch from "../../components/CustomDiscussionSearch";
import IndexPage from 'flarum/components/IndexPage';
import Stream from 'flarum/utils/Stream';

export default function () {

  app.discussions.searchValue = Stream('');

  /**
   * Add CustomDiscussionSearch to left IndexPage-toolbar.
   */
  extend(IndexPage.prototype, 'viewItems', function (items) {
    const user = app.session.user;
    // if we have no user - we are not signed in and should not add search bar to discussion
    if(user) {
      items.add('search', CustomDiscussionSearch.component({
        slug: this.attrs.tags
      }), -10);
    }
  });

}
